import { GetterTree } from 'vuex'
import { SystemSettingsState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<SystemSettingsState, RootState> = {
  systemSettings: state => state.systemSettings,
};